import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { useContext, useMemo } from 'react'
import { getSelectedUpgradeOriginUniqueKey } from 'loyalty/lib/benefits/buildLoyaltySelectedUpgradeKey'

/**
 * Returns the origin package and upgrade type for a given target package
 * if the target package was selected for an upgrade.
 */
function useLoyaltyOfferPageSelectedTargetUpgradeOrigin(
  targetPackage: App.Package | App.HotelPackage | undefined,
): Record<App.LoyaltyStayUpgradeType, App.Package | undefined> {
  const { loyaltyTargetStayUpgradesSelected = {}, offer } = useContext(OfferPageStateContext)
  let roomTargetUpgradeOriginPackage: App.Package | undefined
  let packageTargetUpgradeOriginPackage: App.Package | undefined

  Object.entries(loyaltyTargetStayUpgradesSelected).forEach(([upgradeKey, upgradeType]) => {
    if (!upgradeType) return

    const originPackageUniqueKey = getSelectedUpgradeOriginUniqueKey(upgradeKey)
    if (!originPackageUniqueKey) return

    const originPackage = offer?.packages.find(p => p.uniqueKey === originPackageUniqueKey)
    if (!originPackage) return

    const targetUpgradePackageUniqueKey = originPackage.loyalty.upgradeTargetsUniqueKeys?.[upgradeType]

    if (targetUpgradePackageUniqueKey !== targetPackage?.uniqueKey) return

    if (upgradeType === 'package') {
      packageTargetUpgradeOriginPackage = originPackage
    }
    if (upgradeType === 'room') {
      roomTargetUpgradeOriginPackage = originPackage
    }
  })

  return useMemo(() => ({
    package: packageTargetUpgradeOriginPackage,
    room: roomTargetUpgradeOriginPackage,
  }), [packageTargetUpgradeOriginPackage, roomTargetUpgradeOriginPackage])
}

export default useLoyaltyOfferPageSelectedTargetUpgradeOrigin
